// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".step-layout{min-height:100vh}.step-layout header h1{font-size:2.4rem}.step-layout main .form-container{border:2px solid #104182;border-radius:2rem}\n", ""]);
// Exports
module.exports = exports;
